document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

  var CLOSE_DELAY = 150;

  document.querySelectorAll('header-menu details').forEach(function (details) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    var timer;

    // Real click par page khule, hover par menu khule.
    summary.addEventListener(
      'click',
      function (e) {
        if (!e.isTrusted) return; // amaro programmatic open/close
        e.preventDefault();
        e.stopImmediatePropagation();
        var href = summary.getAttribute('data-href');
        if (href && href !== '#') window.location.href = href;
      },
      true
    );

    details.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      if (!details.hasAttribute('open')) summary.click();
    });

    details.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (details.hasAttribute('open')) summary.click();
      }, CLOSE_DELAY);
    });
  });
});